import Types from './actionTypes';
import { STATEMENT_STATUS } from './constants';

const initialState = {
  statements: [],
  loading: false,
  from: '',
  to: '',
  status: '',
};

const reducer = function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case Types.FETCH:
      return { ...state, loading: true, ...payload };
    case Types.FETCHED:
      return { ...state, loading: false, statements: payload.data };
    default:
      return state;
  }
};

export default reducer;
